module.exports = __webpack_public_path__ + "img/Seccion2-Movil.ce81be89.png";